import store from '@/store';

export default class VoiceTransferAcceptedEvent {
  constructor(body) {
    store.dispatch('jobs/setTransferAssistedWaitingConfirmation', false);
  }
}
